import React from 'react';
import { TFunction } from 'i18next';
import { LeafletMarker } from '@uncinc/react-leaflet/dist/types';
import { renderToStaticMarkup } from 'react-dom/server';
import { WasteIcon } from '@hvcgroep/design-system';
import { Container } from '../types';
import normalizeContainerType from './normalizeContainerType';

const formatContainerMarkers = (containers: Container[], excluded: Container['type'][], t: TFunction): LeafletMarker[] => {
  return containers
    .filter((container) => excluded.includes(normalizeContainerType(container.type)) === false)
    .map((container) => ({
      id: `${container.latitude}:${container.longitude}`,
      geoLocation: {
        latitude: Number(container.latitude),
        longitude: Number(container.longitude),
      },
      data: container,
      body: `
        <div class="marker">
          <div class="sr-only">
            ${'container_id' in container ? `
              ${t(`container_locations.popup.title.${normalizeContainerType(container.type)}`)} ${container.container_id}
            ` : container.title}
          </div>
          ${renderToStaticMarkup(<WasteIcon streamUid={normalizeContainerType(container.type)} />)}
        </div>
      `,
    }));
};

export default formatContainerMarkers;
